import axios from 'axios'
import { BUSCAR_ITINERARIOS_ABERTOS_ENCOMENDA_AVULSA } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { RESPONSE_ERROR_HANDLER_POSTPONE_HEADER } from '../../util/responseUtil'
import { URL } from '../../util/ambienteActions'
import { salvarCacheItinerariosAbertosEncomendaAvulsa, carregarCacheItinerariosAbertosEncomendaAvulsa } from '../../util/offlineStorage'

const OFFLINE_AWARE_CONFIG = {
  headers: {
    ...SLOW_REQUEST_CONFIG.headers,
    [RESPONSE_ERROR_HANDLER_POSTPONE_HEADER]: true
  }
}

export default function buscarItinerariosAbertosEncomendaAvulsa (idEmpresa) {
  const url = `${URL}/encomendas-avulsas/empresa/${idEmpresa}/itinerarios-abertos`
  return dispatch => axios.get(url, OFFLINE_AWARE_CONFIG).then(
    response => {
      salvarCacheItinerariosAbertosEncomendaAvulsa(idEmpresa, response.data)
      return dispatch({
        type: BUSCAR_ITINERARIOS_ABERTOS_ENCOMENDA_AVULSA,
        payload: response.data
      })
    }
  ).catch(erro => {
    if (!navigator.onLine || !erro.response) {
      const cache = carregarCacheItinerariosAbertosEncomendaAvulsa(idEmpresa)
      return dispatch({ type: BUSCAR_ITINERARIOS_ABERTOS_ENCOMENDA_AVULSA, payload: cache || [] })
    }
    throw erro
  })
}
